(function () {
    const SELECTORS = {
        control: '[data-pswp-zoom-control]',
        range: '[data-pswp-zoom-range]',
        zoomIn: '[data-pswp-zoom-in]',
        zoomOut: '[data-pswp-zoom-out]',
    };

    const BUTTON_STEP = 10;
    const ANIMATION_DURATION = 150;

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function getZoomLimits(gallery) {
        const item = gallery.currItem;

        if (!item) {
            return {
                min: 1,
                max: 1,
            };
        }

        const min = Number(item.initialZoomLevel) || 1;
        const configuredMax = Number(gallery.options.maxSpreadZoom) || 2;
        const max = Math.max(min, configuredMax);

        return { min, max };
    }

    function rangeValueToZoom(gallery, value) {
        const { min, max } = getZoomLimits(gallery);
        const percentage = clamp(Number(value), 0, 100) / 100;

        return min + (max - min) * percentage;
    }

    function zoomValueToRange(gallery, zoomLevel) {
        const { min, max } = getZoomLimits(gallery);

        if (max <= min) return 0;

        return clamp(
            ((zoomLevel - min) / (max - min)) * 100,
            0,
            100
        );
    }

    function getViewportCenter(gallery) {
        return {
            x: gallery.viewportSize.x / 2,
            y: gallery.viewportSize.y / 2,
        };
    }

    function initializeZoomControl(gallery) {
        if (
            !gallery ||
            !gallery.currItem ||
            gallery.__customZoomControlInitialized
        ) {
            return;
        }

        const template =
            gallery.template || document.querySelector('.pswp');

        const control = template?.querySelector(SELECTORS.control);
        const range = control?.querySelector(SELECTORS.range);
        const zoomIn = control?.querySelector(SELECTORS.zoomIn);
        const zoomOut = control?.querySelector(SELECTORS.zoomOut);

        if (!control || !range || !zoomIn || !zoomOut) {
            console.warn('[PDP zoom] No se encontró el markup del control.');
            return;
        }

        gallery.__customZoomControlInitialized = true;

        const syncControl = () => {
            if (!gallery.currItem) return;

            const rangeValue = Math.round(
                zoomValueToRange(gallery, gallery.getZoomLevel())
            );

            range.value = rangeValue;
            zoomOut.disabled = rangeValue <= 0;
            zoomIn.disabled = rangeValue >= 100;
        };

        const applyZoom = (rangeValue, duration = 0) => {
            const normalizedValue = clamp(Number(rangeValue), 0, 100);
            const zoomLevel = rangeValueToZoom(gallery, normalizedValue);

            range.value = normalizedValue;

            gallery.zoomTo(
                zoomLevel,
                getViewportCenter(gallery),
                duration,
                null,
                () => {
                    syncControl();
                }
            );

            if (duration > 0) {
                window.setTimeout(syncControl, duration + 30);
            } else {
                syncControl();
            }
        };

        const stopPhotoSwipeEvent = (event) => {
            event.stopPropagation();
        };

        [
            'pointerdown',
            'pointerup',
            'mousedown',
            'mouseup',
            'touchstart',
            'touchend',
            'click',
            'pswpTap',
        ].forEach((eventName) => {
            control.addEventListener(eventName, stopPhotoSwipeEvent);
        });

        const handleRangeInput = (event) => {
            event.preventDefault();
            event.stopPropagation();

            applyZoom(event.currentTarget.value);
        };

        range.addEventListener('input', handleRangeInput);
        range.addEventListener('change', handleRangeInput);

        range.addEventListener('pointerdown', (event) => {
            event.stopPropagation();

            if (range.setPointerCapture) {
                range.setPointerCapture(event.pointerId);
            }
        });

        range.addEventListener('pointermove', (event) => {
            event.stopPropagation();
        });

        range.addEventListener('pointerup', (event) => {
            event.stopPropagation();

            if (
                range.releasePointerCapture &&
                range.hasPointerCapture?.(event.pointerId)
            ) {
                range.releasePointerCapture(event.pointerId);
            }
        });

        zoomIn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            applyZoom(
                Number(range.value) + BUTTON_STEP,
                ANIMATION_DURATION
            );
        });

        zoomOut.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            applyZoom(
                Number(range.value) - BUTTON_STEP,
                ANIMATION_DURATION
            );
        });

        gallery.listen('afterChange', () => {
            window.requestAnimationFrame(syncControl);
        });

        gallery.listen('resize', syncControl);
        gallery.listen('zoomGestureEnded', syncControl);
        gallery.listen('pointerUp', syncControl);

        gallery.listen('doubleTap', () => {
            window.setTimeout(syncControl, 350);
        });

        gallery.listen('destroy', () => {
            gallery.__customZoomControlInitialized = false;
        });

        syncControl();
    }

    window.initializePdpPhotoSwipeZoom = initializeZoomControl;
})();